import React from 'react';

import { SkeletonBlock } from '../../../components/skeleton/skeleton';

export default function StoresSkeleton() {
  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
      {[0, 1, 2, 3, 4, 5].map((i) => (
        <div
          key={i}
          className="overflow-hidden rounded-md border border-slate-200 bg-white p-6 shadow-sm dark:border-slate-700 dark:bg-slate-800"
        >
          <div className="flex flex-col items-center text-center">
            <SkeletonBlock className="h-14 w-14 shrink-0 rounded-md" />
            <SkeletonBlock className="mt-3 h-5 w-40 rounded" />
            <SkeletonBlock className="mt-2 h-4 w-full max-w-[12rem] rounded" />
            <SkeletonBlock className="mt-4 h-6 w-24 rounded-full" />
          </div>
        </div>
      ))}
    </div>
  );
}
